/**
 * Query key factory for wishlist queries
 * Provides consistent keys for caching and invalidation
 */
export const wishlistKeys = {
  all: ['wishlist'] as const,
  customer: () => [...wishlistKeys.all, 'customer'] as const,
  mutations: {
    add: ['wishlist', 'add'] as const,
    remove: ['wishlist', 'remove'] as const,
  },
}
